import React, { Component } from 'react';
import styled from 'styled-components';
import Splash from '../../shared/Splash';
import Footer from '../../shared/Footer';
import Content from '../../shared/Content';
import Helmet from 'react-helmet';
import MandatoryCourses from './components/MandatoryCourses';
import AllCourses from './components/AllCourses';
import Bundle from './components/Bundle';
import { withRouter } from 'react-router-dom';
import WhyChooseUs from '../../shared/WhyChooseUs';
import Requirements from '../../shared/Requirements';
import Accreditations from '../../shared/Accreditations';
import BannerSplash from '../../../assets/banner.jpg';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Grid = styled.div`
  width: 85%;
  display: grid;
  grid-gap: 35px;
  height: 100%;
  margin: 2em auto;
  grid-template-columns: 1fr 2fr 1fr;
  grid-auto-rows: 550px auto;
  grid-template-areas:
    'w r a'
    'c c c';
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-template-areas:
      'r '
      'w '
      'a '
      'c ';
  }
`;

const Div = styled.div`
  width: 100%;
  height: 100%;
  background: #cfd3dc;
  padding: 1em 0;
  margin: 0 auto;
`;

class Profession extends Component {
  state = {
    isOpen: false,
  };
  handleClick = () => {
    this.setState(prevState => {
      return {
        isOpen: !prevState.isOpen,
      };
    });
  };

  handleSubmit = () => {
    this.props.history.push({
      pathname: '/findce',
      state: { type: 'change' },
    });
  };

  render() {
    const {
      state,
      profession,
      // img,
      history,
      learnMore,
      totalHours,
      mandatoryHours,
      generalHours,
      allOnline,
      accreditations,
      ceRequirements,
      requiredTime,
      generalTime,
    } = this.props;
    return (
      <Wrapper>
        <Helmet
          title={`${state} | ${profession} AchieveCE`}
          meta={[
            {
              name: 'description',
              content: `${state} page for ${profession} AchieveCE`,
            },
            { property: 'og:type', content: 'website' },
            { property: 'og:title', content: 'Approved Continuing Education' },
            { property: 'og:url', content: 'http://achievece.com' },
          ]}
        />
        <Splash
          navigate={history}
          img={BannerSplash}
          text={[profession, state]}
          id="profession"
          handleSubmit={this.handleSubmit}
        />
        <Bundle />
        <Div>
          <Grid>
            <WhyChooseUs />
            <Requirements
              generalHours={generalHours}
              mandatoryHours={mandatoryHours}
              totalHours={totalHours}
              type="profession"
              allOnline={allOnline}
              ceRequirements={ceRequirements}
            />
            <Accreditations accreditations={accreditations} />
            <Content
              handleClick={this.handleClick}
              isOpen={this.state.isOpen}
              learnMore={learnMore}
            />
          </Grid>
        </Div>
        <div id="courses">
          <MandatoryCourses requiredTime={requiredTime} />
          <AllCourses generalTime={generalTime} />
        </div>
        <Footer />
      </Wrapper>
    );
  }
}

export default withRouter(Profession);



// WEBPACK FOOTER //
// ./src/components/screens/Profession/Profession.jsx